export default [	
	//計價頁面 fpc-quote rfpc  smd  smt pcb
	{
		path: '/pcb-quote',
		name: 'pcb_quote',
		meta:{stay:'pcb'},
		component: () => import('@/views/quote/pcb_quote.vue')
	},
	// {
	// 	path: '/flex-pcb-quote',
	// 	name: 'fpc_quote',
	// 	meta:{stay:'fpc'},
	// 	component: () => import('@/views/quote/fpc_quote.vue')
	// },
	// {
	// 	path: '/rigid-flex-pcb-quote',
	// 	meta:{stay:'rfpc'},
	// 	name: 'rfpc_quote',
	// 	component: () => import('@/views/quote/rfpc_quote.vue')
	// },
	{
		path: '/quote-by-sales',
		meta:{stay:'sales'},
		name: 'quote_sales',
		component: () => import('@/views/quote/quote_sales.vue')
	},
	{
		path: '/pcb-assembly-quote',
		meta:{stay:'smt'},
		name: 'quote_assembly',
		component: () => import('@/views/quote/smt_quote.vue')
	},
	{
		path: '/pcb-stencil-quote',
		meta:{stay:'smd'},
		name: 'quote_stencil',
		component: () => import('@/views/quote/smd_quote.vue')
	},
	{
		path: '/quote-layout',
		meta:{stay:'layout'},
		name: 'quote_layout',
		component: () => import('@/views/quote/layout.vue')
	},
	{
		path: '/bom-service',
		meta:{stay:'bom'},
		name: 'quote_bom',
		component: () => import('@/views/quote/bom.vue')
	},
	{
		path: '/pcb-quote-advance',
		name: 'pcbQuoteAdvance',
		meta:{stay:'pcb_high'},
		component: () => import('@/views/quote/pcb_quote_advance.vue')
	},
]